export default {
  top: '/seminar_application',
  conf: (id) => {
    return `/seminar_application/conf/${id}`;
  },
};
